import React, { Component } from "react";
import { Form, Button, InputGroup, Spinner } from "react-bootstrap";
import { NavLink } from "react-router-dom";

import { Formik } from "formik";
import * as Yup from "yup";

import { connect } from "react-redux";
import { resetState } from "../../../redux/actions/authActions";
import {
  performLogin,
  fetchProfile,
} from "../../../redux/actionCreators/authCreators";
import StorageManager from "../../../storage/StorageManager";
import { SAVED_EMAIL } from "../../../storage/StorageKeys";
import { showErrorToast } from "../../components/toast";

import { Checkbox } from "../../components/Form";
import ImageCarousel from "../../components/ImageCarousel";

import { APP_STORE_LINK, PLAY_STORE_LINK } from "../../uiConsts";

import Logo from "../../assets/images/logo.png";
import CharacterLogo from "../../assets/images/characterLogo.png";
import AppStoreLogo from "../../assets/images/Appstore_btn.png";
import PlayStoreLogo from "../../assets/images/playstore_btn.png";

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      passwordVisible: false,
      rememberMe: false,
    };
  }

  componentDidMount() {
    this.props.resetState();
  }

  handleLogin = async (email, password) => {
    const { rememberMe } = this.state;
    const resp = await this.props.performLogin(email, password);

    if (resp.status === 200) {
      StorageManager.put(SAVED_EMAIL, rememberMe ? email : "");
      const resp = await this.props.fetchProfile();
      const {
        data: { userType, isRegistered },
      } = resp;
      if (isRegistered === true) {
        this.props.history.push("/home");
      } else if (userType === null || userType === "") {
        this.props.history.push("/auth/passcode");
      } else if (userType === "subscribed") {
        this.props.history.push("/auth/complete-profile?userType=subscribed");
      }
    } else {
      showErrorToast(resp.data.message);
    }
  };

  render() {
    const { passwordVisible, rememberMe } = this.state;
    const { submitting } = this.props;
    let email = "";
    if (StorageManager.get(SAVED_EMAIL)) {
      email = StorageManager.get(SAVED_EMAIL);
    }
    return (
      <div className="d-flex justify-content-center  bg-primary fullScreen">
        <div className="d-flex page-card-sm page-padding">
          <div className="d-flex flex-column align-items-center bg-white p-4 page-card-sm card-width">
            <img src={Logo} alt="CharacterCounts! Logo" />
            <Formik
              initialValues={{ email, password: "" }}
              validationSchema={Yup.object().shape({
                email: Yup.string().email("Invalid email").required("Required"),
                password: Yup.string().required("Required"),
              })}
              onSubmit={({ email, password }) => {
                this.handleLogin(email, password);
              }}
            >
              {({ handleChange, handleSubmit, values, errors, touched }) => (
                <Form onSubmit={handleSubmit} className="w-100">
                  <Form.Group>
                    <Form.Label className="text-muted">
                      Email address
                    </Form.Label>
                    <Form.Control
                      type="email"
                      onChange={handleChange("email")}
                      value={values.email}
                      isInvalid={!!errors.email && touched.email}
                    />
                  </Form.Group>

                  <Form.Group>
                    <Form.Label className="text-muted">Password</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type={passwordVisible ? "text" : "password"}
                        onChange={handleChange("password")}
                        value={values.password}
                        isInvalid={!!errors.password && touched.password}
                      />
                      <InputGroup.Append>
                        <InputGroup.Text
                          style={{ cursor: "pointer", userSelect: "none" }}
                          onClick={() =>
                            this.setState({ passwordVisible: !passwordVisible })
                          }
                        >
                          <i className="material-icons">visibility</i>
                        </InputGroup.Text>
                      </InputGroup.Append>
                    </InputGroup>
                  </Form.Group>
                  <div className="d-flex justify-content-between">
                    <Form.Group>
                      <Checkbox
                        label="Remember me"
                        checked={rememberMe}
                        onClick={() =>
                          this.setState({ rememberMe: !rememberMe })
                        }
                      />
                    </Form.Group>
                    <NavLink
                      to="/auth/forgot-password"
                      className="text-primary"
                    >
                      Forgot password?
                    </NavLink>
                  </div>
                  <Button
                    type="submit"
                    variant="primary"
                    disabled={submitting}
                    block
                  >
                    <Spinner
                      hidden={!submitting}
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      className="mr-2"
                    />
                    Sign In
                  </Button>
                  <div className="mt-4 d-flex flex-column align-items-center">
                    <span className="mb-1 text-muted">
                      Don't have an account?
                    </span>
                    <Button
                      variant="danger"
                      onClick={() => {
                        this.props.history.push("/auth/signup");
                      }}
                      block
                    >
                      Create New Account
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
            <div className="d-flex flex-column align-items-center mt-2">
              <span className="text-muted text-center small">powered by</span>
              <img
                className="d-block"
                src={CharacterLogo}
                alt="CharacterCounts! Logo"
              />
            </div>
            <div className="d-flex flex-column align-items-center mt-2">
              <span className="text-muted text-center small">Get the app!</span>
              <div style={{ display: "flex", marginTop: 6 }}>
                <a
                  href={APP_STORE_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className="d-block mr-3"
                    src={AppStoreLogo}
                    alt="iOS App Link"
                  />
                </a>
                <a
                  href={PLAY_STORE_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className="d-block"
                    src={PlayStoreLogo}
                    alt="Android App Link"
                  />
                </a>
              </div>
            </div>
          </div>
          <ImageCarousel />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ auth: { submitting, error } }) => ({
  submitting,
  error,
});

const mapDispatchToProps = (dispatch) => ({
  resetState: () => dispatch(resetState()),
  performLogin: (email, password) => dispatch(performLogin(email, password)),
  fetchProfile: () => dispatch(fetchProfile()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
